import React from 'react';
import {Routes, Route} from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Founders from './components/Founders';
import Services from './components/Services';


function App() {
  return (
    <Routes>
      <Route path='/' element={<LandingPage />}/>
      <Route path='/founders' element={<Founders />}/>
      <Route path='/services' element={<Services />}/>
    </Routes>
  );
}

export default App;